<template>
  <div class="base-model__header">
    <p
      class="base-model__header-title base-model__header-title--left heading-h4"
    >
      {{ title }}
    </p>
    <button
      role="button"
      aria-label="Dismiss modal"
      class="button--text button--icon base-model__header-close"
      @click="closeModal"
    >
      <i class="icon icon-close icon--xs" aria-hidden="true"></i>
    </button>
  </div>

  <div class="base-model__body">
    <slot></slot>
    <div v-if="showLinks" class="aftersales-modal__links">
      <ul class="ul--cta">
        <li v-for="button in filteredProp" :key="button.name">
          <button
            role="button"
            class="iconcta iconcta--multi-layout icon--hoverable hover-shadow"
            :class="{ 'bg-KQ-Grey6-50': hasGreyBg }"
            @click="() => toggleModal(button.name)"
          >
            <span class="sr-only">{{ button.ariaLabel }}</span>
            <div class="iconcta__holder">
              <i :class="button.icon" aria-hidden="true" />
            </div>
            <div class="iconcta__content bg-KQ-White">
              <p class="text-KQ-Grey1">{{ button.title }}</p>
            </div>
            <div v-if="hasChevron" class="iconcta__chevron">
              <i
                class="icon icon-chevronright icon-color--red icon--xxs"
                aria-hidden="true"
              />
            </div>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  contentType: {
    type: String,
    default: '',
  },
  afterSalesLinks: {
    type: undefined,
    default: () => [],
  },
  showLinks: {
    type: Boolean,
    default: false,
  },
  hasChevron: {
    type: Boolean,
    default: true,
  },
});

const afterSalesLinksRef = ref([]);

const emit = defineEmits(['close:modal', 'openModal']);

function closeModal() {
  emit('close:modal', false);
}

const toggleModal = (modalName, event) => {
  closeModal();
  emit('openModal', modalName);
};

onMounted(() => {
  if (typeof props.afterSalesLinks === 'object') {
    afterSalesLinksRef.value = props.afterSalesLinks;
  } else if (typeof props.afterSalesLinks === 'string') {
    if (isJSONString(props.afterSalesLinks)) {
      afterSalesLinksRef.value = JSON.parse(props.afterSalesLinks);
    }
  }
});

const filteredProp = computed(() => {
  return afterSalesLinksRef.value.filter(
    (link) => link.name !== props.contentType,
  );
});
</script>
